import "../App.css"
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'


export function AppTail() {

    return (
        <div id="apptail" className="AppTail">
            <Box sx={{ position: "relative", width: "100%" }}>
                <Divider
                    sx={{
                        marginTop: 1,
                        marginBottom: 1,
                        boxShadow: "0px -2px 5px rgba(0, 0, 0, 0.1)", // Shadow effect
                    }}
                />
                <Box sx={{ padding: 1, paddingLeft: 2 }}>
                    © 2025 - {new Date().getFullYear()} Marrer Unterlagsböden AG. All rights reserved.
                </Box>
            </Box>


        </div>
    );
}
